export class CourtroomLimitExceeded extends Error {
  constructor() {
    super('Court has reached courtroom limit')
    Object.setPrototypeOf(this, CourtroomLimitExceeded.prototype)
  }
}
